class CartCount extends HTMLElement {
  constructor() {
    super();
    this.cartCountBubble = document.querySelector('[data-cart-count]');
    this.cartCount = this.cartCountBubble.querySelector('span:not(.visually-hidden)');
    this.cartCountHidden = this.cartCountBubble.querySelector('.visually-hidden');
    this.hwCartCount = document.querySelector('.hw__cart-count');
    
    // Subscribe to cart updates
    document.addEventListener('cart:updated', this.updateCartCount.bind(this));
    document.addEventListener('cart:refresh', this.updateCartCount.bind(this));
    
    // Initial update
    this.updateCartCount();
  }

  updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const count = cart.item_count;
        
        // Update cart count bubble
        if (this.cartCount) {
          this.cartCount.textContent = count;
          this.cartCountHidden.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
          
          // Show/hide bubble based on count
          if (count > 0) {
            this.cartCountBubble.style.display = 'flex';
          } else {
            this.cartCountBubble.style.display = 'none';
          }
        }

        // Update hw__cart-count
        if (this.hwCartCount) {
          this.hwCartCount.textContent = count;
        }
      })
      .catch(error => console.error('Error updating cart count:', error));
  }
}

// Initialize the cart count component
customElements.define('cart-count', CartCount);

// Add event listener for cart updates
document.addEventListener('DOMContentLoaded', () => {
  const cartCount = new CartCount();
  
  // Listen for Shopify cart updates
  document.addEventListener('cart:updated', () => {
    cartCount.updateCartCount();
  });
}); 